import React from 'react';
import styled from 'styled-components';
import posed from 'react-pose';
import ga from 'react-ga';
import json from './works';

const Works = props => (
  <div className={props.className}>
    <div className="wrapper">
      <PosedWorks className="container" pose="open" initialPose="closed">
        {renderWorks()}
      </PosedWorks>
    </div>
  </div>
);

const renderWorks = () => json.data.map(work => <Work {...work} key={work.id} />);
const Work = props => (
  <PosedWork className="item-container">
    <div className="item">
      <ga.OutboundLink eventLabel={props.url} to={props.url} className="img" target="_blank">
        <img
          src={props.imgUrl || 'https://via.placeholder.com/400x250'}
          alt={props.title}
          style={{ objectFit: props.objectFit }}
        />
      </ga.OutboundLink>
      <div className="date">{props.date}</div>
      <div className="title">{props.title}</div>
      <div className="description">{props.description}</div>
    </div>
  </PosedWork>
);

const PosedWork = posed.div({
  open: { y: 0, opacity: 1 },
  closed: { y: 40, opacity: 0 },
});
const PosedWorks = posed.div({
  open: {
    opacity: 1,
    during: 100,
    delayChildren: 100,
    staggerChildren: 70,
  },
  closed: {
    opacity: 0,
  },
});

export default styled(Works)`
  height: 100%;
  display: flex;
  justify-content: center;
  .wrapper {
    margin: 30px;
    height: calc(100% - 60px);
    width: 1000px;
    position: relative;
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.5);
    background: transparent;
    border-radius: 10px;
    overflow: auto;
  }
  .container {
    width: 100%;
    min-height: 100%;
    border-radius: 10px;
    padding: 50px 50px 80px;
    background: rgba(0, 0, 0, 0.6);
    display: grid;
    grid-template-columns: repeat(auto-fill, 400px);
    grid-gap: 60px;
    justify-content: center;
    color: white;
  }
  .item-container:nth-child(2n) .item {
    transform: translateY(35px);
  }
  .img {
    display: block;
    width: 100%;
    height: 250px;
    filter: drop-shadow(0 0 30px rgba(0, 0, 0, 0.5));
    border-radius: 2px;
    overflow: hidden;
    transition: all 0.5s;
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      transform: translateY(-15px);
    }
  }
  .date {
    text-align: right;
    font-size: 0.8em;
  }
  .title {
    font-size: 1.3em;
    font-weight: 500;
    position: relative;
    padding-left: 20px;
  }
  .title:before {
    position: absolute;
    content: '';
    width: 5px;
    top: 1px;
    left: 0;
    bottom: 1px;
    background: white;
  }
  .description {
    margin-top: 10px;
    font-size: 0.95em;
    color: rgba(222, 222, 222);
  }
  @media (max-width: 768px) {
    .wrapper {
      margin: 10px 0 0;
    }
    .item-container:nth-child(2n) .item {
      transform: translateY(0);
    }
  }
  @media (max-width: 500px) {
    .container {
      grid-template-columns: repeat(auto-fill, 350px);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Works/index.js